module.exports = __webpack_public_path__ + "img/MAF.c9345617.svg";